import { render } from "./ReferralBindBanner.vue?vue&type=template&id=23d99ae0&scoped=true"
import script from "./ReferralBindBanner.vue?vue&type=script&lang=js"
export * from "./ReferralBindBanner.vue?vue&type=script&lang=js"

import "./ReferralBindBanner.vue?vue&type=style&index=0&id=23d99ae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d99ae0"]])

export default __exports__